import React, { useState } from 'react';
import { useTheme } from '../../../context/ThemeContext';
import { THEMES } from '../../../data/themeConfig';

const ThemeSelector = ({ onClose }) => {
  const { currentTheme, setTheme } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(currentTheme.id);

  const handleThemeSelect = (themeId) => {
    setSelectedTheme(themeId);
    setTheme(themeId);
    if (onClose) {
      setTimeout(() => onClose(), 300); // Close after animation
    }
  };

  const themeColors = {
    WHITE: { bg: 'bg-white', border: 'border-gray-200', icon: '⚪' },
    BLUE: { bg: 'bg-blue-500', border: 'border-blue-600', icon: '🔵' },
    BLACK: { bg: 'bg-gray-900', border: 'border-gray-800', icon: '⚫' },
    EMERALD: { bg: 'bg-emerald-500', border: 'border-emerald-600', icon: '💚' },
    PURPLE: { bg: 'bg-purple-500', border: 'border-purple-600', icon: '💜' },
    GOLD: { bg: 'bg-yellow-500', border: 'border-yellow-600', icon: '💛' }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">เลือกธีม</h2>
      <div className="grid grid-cols-3 gap-4">
        {Object.values(THEMES).map(theme => {
          const isSelected = selectedTheme === theme.id;
          const colorInfo = themeColors[theme.id] || themeColors.WHITE;
          
          return (
            <button
              key={theme.id}
              onClick={() => handleThemeSelect(theme.id)}
              className={`relative p-4 rounded-lg border-2 transition-all ${
                isSelected
                  ? `${colorInfo.border} ${colorInfo.bg} text-white shadow-lg scale-105`
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex flex-col items-center gap-2">
                <div className={`w-12 h-12 rounded-full ${colorInfo.bg} flex items-center justify-center text-2xl`}>
                  {colorInfo.icon}
                </div>
                <span className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-gray-700'}`}>
                  {theme.name}
                </span>
              </div>
              {isSelected && (
                <div className="absolute top-2 right-2">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <p className="text-sm text-gray-600 text-center">
          ธีมที่เลือก: <span className="font-semibold text-gray-800">{THEMES[selectedTheme]?.name}</span>
        </p>
      </div>
    </div>
  );
};

export default ThemeSelector;


